<template>
  <v-row
    :style="
      $vuetify.theme.dark
        ? 'height: 104px; background-color: var(--v-surface_tertiary-base)'
        : 'height: 104px; background-color: var(--v-surface_primary-base)'
    "
    class="d-flex flex-row align-center pr-5 pl-5 ma-0"
  >
    <v-col class="d-flex align-center" cols="8" sm="5" md="4" lg="3">
      <label class="labelProd mr-3">Produção: </label>
      <v-select
        v-if="producoes"
        dense
        hide-details
        class="prod-select"
        v-model="cod_producao"
        :items="producoes.items"
        item-text="nome_producao"
        item-value="cod_producao"
        filled
        solo
        
        aria-label="Selecione a produção"
        @change="onChangeProducao"
        return-object
        :background-color="
          $vuetify.theme.dark ? 'surface_neutral_default' : 'surface_secondary'
        "
        flat
      >
         <template #label>
          Selecione uma produção
        </template>
        <template #selection="{ item }">
          <span class="prod-pick">{{ item.nome_producao || item.sig_producao }}</span>
        </template>
        <template #item="{ item }">
          <div class="prod-opt">
            <span class="prod-opt__nome">{{ item.nome_producao || item.sig_producao }}</span>
            <span class="prod-opt__meta">
              {{ item.sig_producao
              }}<template v-if="pracaSigla(item.cod_praca)"> · {{ pracaSigla(item.cod_praca) }}</template>
            </span>
          </div>
        </template>
      </v-select>
    </v-col>
    <v-col
      v-if="modoModeracao === 'GloboGraphics' && mySites.length"
      class="d-flex align-center"
      cols="8"
      sm="5"
      md="4"
      lg="3"
    >
      <label class="labelProd mr-3">Site: </label>
      <v-select
        :value="selectedSiteSigla"
        :items="mySites"
        item-text="sigla"
        item-value="sigla"
        dense
        hide-details
        filled
        solo
        @change="selectSite"
        label="Escolha um site"
        aria-label="Selecione o site GloboGraphics"
        :background-color="
          $vuetify.theme.dark ? 'surface_neutral_default' : 'surface_secondary'
        "
        flat
      />
    </v-col>

    <v-col
      v-if="modoModeracao === 'Noticias'"
      class="d-flex align-center"
      cols="8"
      sm="5"
      md="4"
      lg="3"
    >
      <label class="labelProd mr-3">Portal: </label>
      <v-select
        v-if="currentPortais"
        v-model="cod_portal"
        :items="currentPortais"
        item-text="dsc_portal"
        item-value="cod_portal"
        dense
        hide-details
        filled
        solo
        return-object
        @change="onChangePortal"
        label="Escolha um portal"
        aria-label="Selecione o portal de notícias"
        :background-color="
          $vuetify.theme.dark ? 'surface_neutral_default' : 'surface_secondary'
        "
        flat
      />
    </v-col>

    <v-col
      v-if="modoModeracao === 'Enquetes'"
      class="d-flex align-center"
      cols="8"
      sm="5"
      md="4"
      lg="3"
    >
      <label class="labelProd mr-3">Portal: </label>
      <v-select
        v-if="enquetesPortais"
        v-model="id_portal_enquete"
        :items="enquetesPortais"
        item-text="dsc_nome"
        item-value="id"
        dense
        hide-details
        filled
        solo
        return-object
        @change="onChangePortal"
        label="Escolha um portal"
        aria-label="Selecione o portal de enquetes"
        :background-color="
          $vuetify.theme.dark ? 'surface_neutral_default' : 'surface_secondary'
        "
        flat
      />
    </v-col>

    <v-col v-if="modoModeracao === 'Noticias'" v-show="false">
      <ModalInserirNoticia :cod_pasta="cod_pasta" />
    </v-col>
    <v-col v-if="cod_producao && novaColaboracao && isMidiasModeracao">
      <ModalInserirColaboracao
        :cod_producao="Number(cod_producao)"
        :cod_pasta="cod_pasta"
      />
    </v-col>
    <v-col v-if="cod_producao && modoModeracao === 'Cronometro'">
      <ModalInserirCronometro
        :cod_producao="Number(cod_producao)"
        :cod_pasta="cod_pasta"
      />
    </v-col>
    <v-col class="d-flex align-center justify-end view-options" :class="{ 'view-options--noticias': modoModeracao === 'Noticias' }">
      <!-- YouTube subscriber widget — count + Exibir-na-Tarja toggle.
           Visually separated from the action buttons (Tarja, Mosaico) by a
           vertical divider so the toggle isn't confused with the buttons. -->
      <template v-if="cod_producao && producao.num_inscritos_youtube && isMidiasModeracao">
        <YoutubeSubscriberCounter
          :cod-producao="Number(cod_producao)"
          :num-inscritos-youtube="producao.num_inscritos_youtube"
          :flg-exibir-inscritos-tarja="
            producao.config_tarja && producao.config_tarja.flg_exibir_inscritos_youtube
          "
          @toggle-tarja-display="handleToggleTarjaInscritosDisplay"
        />
        <v-divider vertical class="view-divider" />
      </template>

      <!-- Ver Tela de Exibição (Noticias) -->
      <router-link
        v-if="cod_producao && [1].includes(selectedTabNumber)"
        :to="{ name: 'noticias' }"
        target="_blank"
        class="view-link"
        aria-label="Abrir tela de exibição em nova aba"
      >
        <v-btn small class="view-btn">
          <v-icon small class="mr-1">mdi-monitor</v-icon>
          Tela de exibição
          <v-icon x-small class="ml-1 view-external">mdi-open-in-new</v-icon>
        </v-btn>
      </router-link>

      <!-- Ver Tarja -->
      <router-link
        v-if="showVerTarjaButton"
        :to="{
          name: 'tarja',
          query: { ...(modoModeracao === 'Cameras' ? { mode: 'cam' } : {}) },
        }"
        target="_blank"
        class="view-link"
        aria-label="Abrir tarja em nova aba"
      >
        <v-btn small class="view-btn">
          <v-icon small class="mr-1">mdi-television</v-icon>
          Tarja
          <v-icon x-small class="ml-1 view-external">mdi-open-in-new</v-icon>
        </v-btn>
      </router-link>

      <!-- Ver Mosaico + Controle -->
      <template
        v-if="
          (producao && producao.settings?.mosaico?.enabled && modoModeracao === 'Midias') ||
          (cod_producao && modoModeracao === 'Cameras')
        "
      >
        <div class="view-group">
          <router-link
            :to="{
              name:
                cod_producao === 44 || cod_producao === 6
                  ? 'gnews'
                  : modoModeracao === 'Cameras'
                  ? 'mosaico-cameras'
                  : 'mosaico',
            }"
            target="_blank"
            class="view-link"
            aria-label="Abrir mosaico em nova aba"
          >
            <v-btn small class="view-btn view-btn-left">
              <v-icon small class="mr-1">mdi-view-grid</v-icon>
              Mosaico
              <v-icon x-small class="ml-1 view-external">mdi-open-in-new</v-icon>
            </v-btn>
          </router-link>
          <ModalControleMosaico
            :cod-producao="cod_producao"
            :id-config-ativa="producao.id_config_mosaico_ativa"
          />
        </div>
      </template>

      <!-- Ver Enquete -->
      <template v-if="cod_producao && modoModeracao === 'Enquetes'">
        <router-link :to="{ name: 'enquete' }" target="_blank" class="view-link" aria-label="Abrir enquete em nova aba">
          <v-btn small class="view-btn">
            <v-icon small class="mr-1">mdi-poll</v-icon>
            Enquete
            <v-icon x-small class="ml-1 view-external">mdi-open-in-new</v-icon>
          </v-btn>
        </router-link>
      </template>

      <!-- Ver Cena -->
      <template v-if="cod_producao && modoModeracao === 'GloboGraphics'">
        <router-link :to="{ name: 'cena' }" target="_blank" class="view-link">
          <v-btn small class="view-btn">
            <v-icon small class="mr-1">mdi-palette</v-icon>
            Cena
            <v-icon x-small class="ml-1 view-external">mdi-open-in-new</v-icon>
          </v-btn>
        </router-link>
      </template>
      <ModalConfiguracoesProducao
        v-if="cod_producao && producao"
        :changeColuna="changeColuna"
        :num_coluna_telao="num_coluna_telao"
        :cod-producao="cod_producao"
        :producao="producao"
        :sigla-producao="producao.sig_producao"
        :modo-moderacao="modoModeracao"
      >
      </ModalConfiguracoesProducao>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalInserirNoticia from "../Modal/Noticia/ModalInserirNoticia.vue";
import ModalInserirColaboracao from "../Modal/Colaboracao/ModalInserirColaboracao.vue";
import ModalInserirCronometro from "../Modal/Cronometro/ModalInserirCronometro.vue";
import ModalControleMosaico from "../Modal/ConfiguracoesProducao/ModalControleMosaico.vue";
import ModalConfiguracoesProducao from "../Modal/ConfiguracoesProducao/ModalConfiguracoesProducao.vue";
import YoutubeSubscriberCounter from "../YoutubeSubscriberCounter.vue";

export default {
  name: "ProducaoBar",
  components: {
    ModalInserirNoticia,
    ModalInserirColaboracao,
    ModalControleMosaico,
    ModalConfiguracoesProducao,
    ModalInserirCronometro,
    YoutubeSubscriberCounter,
  },
  props: {
    isMidiasModeracao: Boolean,
    selectedTabNumber: Number,
    changeColuna: Function,
    num_coluna_telao: Number,
    cod_pasta: Number,
  },
  data() {
    const mappingTabNumberToName = {
      0: "Midias",
      1: "Noticias",
      2: "Enquetes",
      3: "Cameras",
      4: "Cronometro",
      5: "GloboGraphics",
    };
    const selectedProducao = this.$store.state.producoes.selectedProducao;
    const selectedPortalNoticias = this.$store.state.portais.selectedPortal;
    const selectedPortalEnquetes = this.$store.state.enquetes.selectedPortal;
    const enquetesPortais = this.$store.state.enquetes.portais;

    return {
      cod_producao: selectedProducao?.cod_producao || null,
      cod_portal: selectedPortalNoticias?.cod_portal || null,
      novaColaboracao: selectedProducao?.settings?.colaboracao?.nova_colaboracao ?? false,
      id_portal_enquete: selectedPortalEnquetes || null,
      producao: selectedProducao || {},
      portal: {},
      portal_enquetes: selectedPortalEnquetes && enquetesPortais
        ? (enquetesPortais.find(p => String(p.id) === String(selectedPortalEnquetes)) || {})
        : {},
      modoModeracao: mappingTabNumberToName[this.$store.state.moderacao.modoModeracao] || null,
      mappingTabNumberToName,
    };
  },
  async created() {
    this.modoModeracao = this.mappingTabNumberToName[this.selectedTabNumber];

    // Restore production immediately from Vuex if available, fetch in background if needed
    const existingProducoes = this.producoes?.items;
    if (!existingProducoes || existingProducoes.length === 0) {
      await this.getProducoes({
        page: 1,
        filtro_texto: "",
        flg_ativo: "S",
        isAdmin: this.isAdm,
        dsc_login_usuario: this.username,
      });

      const storedProd = Number(
        localStorage.getItem("@socialcam/selected_option_production")
      );
      if (storedProd && this.producoes?.items) {
        await this.setSelectedProducao(
          ...this.producoes.items.filter((p) => p.cod_producao === storedProd)
        );
      }
    }

    this.cod_producao = this.$store.state.producoes.selectedProducao
      ? this.$store.state.producoes.selectedProducao.cod_producao
      : null;
    this.producao = this.$store.state.producoes.selectedProducao || {};

    // Always load portais for display name resolution
    if (!this.$store.state.portais.portais) {
      this.getPortais();
    }

    // Load praças so the selector can show each production's praça sigla
    if (!this.pracas) {
      this.getPracas();
    }

    if (this.$store.state.moderacao.modoModeracao === 1) {
      // Restore Noticias portal from Vuex immediately, fetch only if empty
      if (!this.noticiasPortais || this.noticiasPortais.length === 0) {
        await this.getPortais();
      }

      // Restore selection from Vuex first, then localStorage fallback
      if (this.$store.state.portais.selectedPortal) {
        this.cod_portal = this.$store.state.portais.selectedPortal.cod_portal;
      } else {
        const localStorageCodPortal = localStorage.getItem("@socialcam/cod_portal");
        if (localStorageCodPortal && this.currentPortais) {
          const match = this.currentPortais.find(
            (portal) => String(portal.cod_portal) === localStorageCodPortal
          );
          if (match) {
            await this.setSelectedPortal(match);
            this.cod_portal = match.cod_portal;
          }
        }
      }
    } else if (this.$store.state.moderacao.modoModeracao === 2) {
      // Restore Enquetes portal from Vuex immediately, fetch only if empty
      if (!this.enquetesPortais || this.enquetesPortais.length === 0) {
        await this.getPortaisEnquetes();
      }

      // Restore selection from Vuex first, then localStorage fallback
      if (this.$store.state.enquetes.selectedPortal) {
        const match = this.enquetesPortais?.find(
          (portal) => String(portal.id) === String(this.$store.state.enquetes.selectedPortal)
        );
        if (match) {
          this.portal_enquetes = match;
          this.id_portal_enquete = match.id;
        }
      } else {
        const localStorageCodPortalEnquetes = localStorage.getItem(
          "@socialcam/cod_portal_enquetes"
        );

        if (localStorageCodPortalEnquetes && this.enquetesPortais) {
          const match = this.enquetesPortais.find(
            (portal) => String(portal.id) === String(localStorageCodPortalEnquetes)
          );
          if (match) {
            await this.setSelectedPortalEnquetes(match.id);
            this.portal_enquetes = match;
            this.id_portal_enquete = match.id;
          }
        }

      }
    }

    this.isDark = localStorage.getItem("@socialcam/is_dark_theme") === "true";
  },

  computed: {
    ...mapGetters({
      noticiasPortais: "portais/getterPortais",
      enquetesPortais: "enquetes/getterPortaisEnquetes",
      producoes: "producoes/getterProducoes",
      pracas: "pracas/getterPracas",
      isAdm: "users/isAdm",
      username: "users/username",
    }),
    ...mapGetters("sites", {
      mySites: "getterMySites",
      selectedSiteSigla: "getterSelectedSiteSigla",
    }),
    currentPortais() {
      if (this.$store.state.moderacao.modoModeracao === 1) {
        return this.noticiasPortais;
      } else if (this.$store.state.moderacao.modoModeracao === 2) {
        return this.$store.state.enquetes.portais;
      }
      return [];
    },
    showVerTarjaButton() {
      if (!this.cod_producao) return false;

      const producaoHasFlgTarjaMidia =
        this.modoModeracao === "Midias" && !!this.producao.settings?.tarja?.enabled;
      const producaoHasFlgTarjaCronometro =
        this.modoModeracao === "Cronometro" && !!this.producao.settings?.tarja?.cronometro;
      const isCameraModeracaoMode = this.modoModeracao === "Cameras";

      return producaoHasFlgTarjaMidia || producaoHasFlgTarjaCronometro || isCameraModeracaoMode;
    },
  },

  methods: {
    ...mapActions({
      changeCodProducao: "colaboracoes_aprovadas/changeCodProducao",
      setSelectedProducao: "producoes/setSelectedProducao",
      setSelectedPortal: "portais/setSelectedPortal",
      getPortais: "portais/getPortais",
      getPortaisEnquetes: "enquetes/getPortaisEnquetes",
      setSelectedPortalEnquetes: "enquetes/setSelectedPortal",
      getProducoes: "producoes/getProducoes",
      getPracas: "pracas/getPracas",
    }),
    // The GloboGraphics view owns loading the production's sites (it must resolve the
    // site before its workflow loads); the bar just renders the selector + selection.
    ...mapActions("sites", ["selectSite"]),

    pracaSigla(codPraca) {
      if (!codPraca || !this.pracas) return "";
      const praca = this.pracas.find((p) => p.cod_praca === codPraca);
      return praca ? praca.sig_praca : "";
    },

    async onChangeProducao(e) {
      this.cod_producao = e.cod_producao;
      localStorage.setItem("@socialcam/selected_option_production", e.cod_producao);
      localStorage.setItem("@socialcam/usar_tela_descanso", e.settings?.mosaico?.usar_tela_descanso ?? false);

      // Just adopt the production as-is. Previous code force-reset
      // flg_exibir_inscritos_youtube to false here on every production switch,
      // which overwrote the user's persisted YouTube/tarja preference each
      // time they logged in or switched between productions.
      await this.setSelectedProducao(e);
      this.producao = e;
    },

    onChangePortal(e) {
      if (this.$store.state.moderacao.modoModeracao === 1) {
        this.portal = e;
        this.cod_portal = e.cod_portal;
        this.setSelectedPortal(e);
        localStorage.setItem("@socialcam/cod_portal", e.cod_portal);
      }

      if (this.$store.state.moderacao.modoModeracao === 2) {
        this.portal_enquetes = e;
        this.id_portal_enquete = e.id;
        this.setSelectedPortalEnquetes(e.id);
        localStorage.setItem("@socialcam/cod_portal_enquetes", e.id);
      }
    },

    handleToggleTarjaInscritosDisplay() {
      // TODO: implement tarja inscritos display toggle
    },
  },

  watch: {
    "$store.state.producoes.selectedProducao"(newValue) {
      this.producao = newValue || {};
      this.novaColaboracao = newValue?.settings?.colaboracao?.nova_colaboracao ?? false;
      if (newValue?.cod_producao) this.cod_producao = newValue.cod_producao;
    },
    "$store.state.moderacao.modoModeracao": async function (newValue) {
      this.modoModeracao = this.mappingTabNumberToName[newValue];

      if (newValue === 1) {
        await this.getPortais();

        const localStorageCodPortal = localStorage.getItem("@socialcam/cod_portal");
        if (localStorageCodPortal && this.currentPortais) {
          const match = this.currentPortais.find(
            (portal) => String(portal.cod_portal) === localStorageCodPortal
          );
          if (match) {
            await this.setSelectedPortal(match);
            this.cod_portal = match.cod_portal;
          }
        }
      } else if (newValue === 2) {
        await this.getPortaisEnquetes();

        const localStorageCodPortalEnquetes = localStorage.getItem("@socialcam/cod_portal_enquetes");
        if (localStorageCodPortalEnquetes && this.enquetesPortais) {
          const match = this.enquetesPortais.find(
            (portal) => String(portal.id) === String(localStorageCodPortalEnquetes)
          );
          if (match) {
            await this.setSelectedPortalEnquetes(match.id);
            this.id_portal_enquete = match.id;
            this.portal_enquetes = match;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* View buttons */
.view-options {
  gap: 8px;
  --view-accent: var(--v-primary-base);
  --view-accent-rgb: 0, 224, 116;
}

// Vertical separator between the YouTube widget and the action buttons
// (Tarja, Mosaico). Keeps the toggle visually distinct from those buttons.
// Vuetify's v-divider--vertical defaults to `align-self: stretch` + `height:
// inherit`, which makes it span the tallest sibling (the YouTube widget) and
// read off-center next to the shorter Tarja/Mosaico buttons. Pin to the
// button height and center it explicitly.
.view-divider {
  height: 36px !important;
  max-height: 36px !important;
  align-self: center;
  margin: 0 6px;
  border-color: var(--sc-border-default) !important;
}

.view-options--noticias {
  --view-accent: #7AB9FF;
  --view-accent-rgb: 122, 185, 255;
}

.view-link {
  text-decoration: none;
}

.view-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  background: var(--sc-surface-tint-hover) !important;
  border: 1px solid var(--sc-border-default) !important;
  border-radius: var(--sc-radius-md) !important;
  color: var(--v-text_primary-base) !important;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  padding: 0 16px !important;
  height: 36px !important;

  &:hover {
    border-color: var(--view-accent) !important;
    background: rgba(var(--view-accent-rgb), 0.1) !important;
    color: var(--view-accent) !important;
  }
}

.view-external {
  opacity: 0.3;
}

.view-btn:hover .view-external {
  opacity: 0.8;
}

/* Mosaico group (button + control icon) */
.view-group {
  display: flex;
  align-items: center;
  background: var(--sc-surface-tint-hover);
  border: 1px solid var(--sc-border-default);
  border-radius: var(--sc-radius-md);
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  height: 36px;

  .view-btn-left {
    border: none !important;
    background: transparent !important;
    border-radius: var(--sc-radius-md) 0 0 var(--sc-radius-md) !important;
    height: 100% !important;
  }

  ::v-deep .bar-icon-btn {
    background: transparent !important;
    border-radius: 0 var(--sc-radius-md) var(--sc-radius-md) 0 !important;
    height: 100% !important;
    width: 36px !important;
    border-left: 1px solid var(--sc-border-emphasis);
  }

  &:hover {
    border-color: var(--view-accent);
    background: rgba(var(--view-accent-rgb), 0.1);
  }
}

/* Cog + Control icon buttons */
::v-deep .bar-cog-btn,
::v-deep .bar-icon-btn {
  background: var(--sc-surface-tint-hover) !important;
  border: 1px solid var(--sc-border-default) !important;
  border-radius: var(--sc-radius-md) !important;
  width: 36px !important;
  height: 36px !important;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  &:hover {
    border-color: var(--view-accent) !important;
    background: rgba(var(--view-accent-rgb), 0.1) !important;
    .v-icon { color: var(--view-accent) !important; }
  }
}

.labelProd {
  color: var(--v-text_primary-base);
  font-weight: 400;
}

/* Production selector — button shows only the name, compact + truncated */

/* Fill the remaining column space and allow shrinking below content width so
   a long name truncates inside the field instead of pushing the neighbouring
   buttons. min-width:0 must propagate down the whole flex chain. */
.prod-select {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}
.prod-select ::v-deep .v-input__slot,
.prod-select ::v-deep .v-select__slot {
  min-width: 0;
}

.prod-select ::v-deep .v-select__selections {
  flex-wrap: nowrap !important;
  overflow: hidden;
  min-width: 0;
}

.prod-select ::v-deep .v-select__selections > .prod-pick {
  flex: 1 1 auto;
  min-width: 0; /* allow ellipsis */
}

.prod-pick {
  font-weight: var(--sc-weight-regular);
  font-size: var(--sc-text-base);
  color: var(--v-text_primary-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Production selector — dropdown option: stacked block (name over sigla · praça),
   full-width divider between items. The negative margin lets the row + divider
   span the v-list-item's horizontal padding. */
.prod-opt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--sc-space-1);
  /* Negative inline margin cancels the v-list-item's 16px (--sc-space-4)
     padding so the row + divider span the full dropdown width. */
  width: calc(100% + var(--sc-space-8));
  margin: 0 calc(-1 * var(--sc-space-4));
  padding: var(--sc-space-2) var(--sc-space-4);
  border-bottom: 1px solid var(--sc-border-subtle);

  &__nome {
    font-weight: var(--sc-weight-regular);
    font-size: var(--sc-text-base);
    color: var(--v-text_primary-base);
    line-height: 1.25;
  }

  &__meta {
    font-size: var(--sc-text-sm);
    color: var(--v-text_secondary-base);
    text-transform: uppercase;
    letter-spacing: var(--sc-tracking-caps);
  }
}
</style>
